import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { breadCrumbStyling } from 'components/forms/new/formStyles';

const BreadcrumbTrail = ({ breadCrumbTrail, handleBackButton }) => {
    const isInvoicesPage = window.location.pathname === '/ui/invoices';

    return (
        <Breadcrumb sx={breadCrumbStyling}>
            {breadCrumbTrail?.map((crumb, index) => {
                const isLastItem = index === breadCrumbTrail.length - 1;
                const isClickable = !isLastItem;

                // Determine click handler based on page and index
                let clickHandler;
                if (isClickable) {
                    if (isInvoicesPage) {
                        if (index === 0) {
                            clickHandler = () =>
                                (window.location.href = '/ui/invoices');
                        } else if (index === 1) {
                            clickHandler = handleBackButton;
                        }
                    } else {
                        if (index === 0) {
                            clickHandler = handleBackButton;
                        }
                    }
                }

                return (
                    <BreadcrumbItem key={index}>
                        {Array.isArray(crumb.path) ? (
                            <BreadcrumbLink
                                as={Link}
                                to={crumb.path[0]}
                                state={crumb.path[1]}
                                onClick={clickHandler}
                                style={{
                                    cursor: isClickable ? 'pointer' : 'default',
                                    color: isClickable ? undefined : 'gray',
                                }}>
                                {crumb.label}
                            </BreadcrumbLink>
                        ) : (
                            <BreadcrumbLink
                                as={isClickable ? Link : 'span'}
                                to={isClickable ? crumb.path : undefined}
                                onClick={clickHandler}
                                style={{
                                    cursor: isClickable ? 'pointer' : 'default',
                                    color: isClickable ? undefined : 'gray',
                                }}>
                                {crumb.label}
                            </BreadcrumbLink>
                        )}
                    </BreadcrumbItem>
                );
            })}
        </Breadcrumb>
    );
};

export default BreadcrumbTrail;
